import { Component, OnInit } from '@angular/core';
import { DataDirectoryService } from "../data-directory/data-directory.service";
import { HomeService } from "../home/home.services";
import { ToastMessageService } from 'src/app/toastr.service';
import { UploadtoliveService } from './uploadtolive.service';

@Component({
  selector: 'app-uploadtolive',
  templateUrl: './uploadtolive.component.html',
  styleUrls: ['./uploadtolive.component.scss']
})
export class UploadtoliveComponent implements OnInit {
  DragData: any = {};
  newArray = [];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  searchValue = "";
  noData = false;
  tempData: any = {};
  changed_Cols: [];
  nullmessage: any = "";
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  // #headerid/
  setWidth: any;
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  secondSectionData: any = {};
  thirdSectionData: any = {};
  fourthSectionData: any = {};
  ApiInformationData: any = {};
  FormulationData: any = {};
  CompetitiveData: any = {};
  ExecutiveData: any = {};
  activeIngredientforPI: any;
  ndaforPI: any;
  brandNameforPI: any;
  CostingData: any = {};
  ipAddress = "";
  uniqNumber: any;
  UserIp: any;
  email: any;
  showConfirmationDialog: boolean = false;
  showUploadButton: boolean = false;

  constructor(private toastService: ToastMessageService, private homeservice: HomeService, private directoryservice: DataDirectoryService, private UploadtoliveService: UploadtoliveService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
  }

  showConfirmDialog() {
    this.showConfirmationDialog = true;
  }

  // onConfirm(brand, nda) {
  //   this.UploadtoliveService.uploadToLiveDb(brand, nda).subscribe((response) => {
  //     console.log('Data uploaded successfully for', `${brand},${nda}`);
  //     this.toastService.success('Data Uploaded successfully!');
  //   });
  //   this.showConfirmationDialog = false;
  // }

  onConfirm(brand, nda) {
    console.log("this.email", this.email)
    this.UploadtoliveService.uploadToLiveDb(brand, nda, this.email).subscribe(
      (response) => {
        console.log('Data uploaded successfully for', `${brand},${nda}`);
        this.toastService.success('Data Uploaded successfully!');
      },
      (error) => {
        // console.log("error", error)
        console.log('Error in uploading data:', error);
        this.toastService.error('Error in uploading data');
      }
    );
    this.showConfirmationDialog = false;
  }

  onCancel() {
    this.showConfirmationDialog = false;
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }


  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.searchValue = "";
    this.DragData = {};
    this.subMolecule = false;
    this.noData = false;
    this.showUploadButton = false;
  }

  searchMolecule() {
    this.submolecules = [];
    this.homeservice.getNdaData(this.searchValue).subscribe((ndaValues) => {
      if (ndaValues["data"].nda_numbers.length > 0) {
        let dropdownvalues = this.arrayToDropdown(
          ndaValues["data"].nda_numbers
        );
        this.submolecules = dropdownvalues;
        this.subMolecule = true;
        this.Molecule = false;
        this.DragData = {};
        this.refEditData = {};
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
        this.DragData = {};
        this.refEditData = {};
        this.tempData = {};
      }
    });
  }

  getData() {
    if (this.selectedSubMolecule !== undefined) {
      let ndaValue = this.selectedSubMolecule["code"];
      this.homeservice.getDrugData(ndaValue).subscribe((MoleculeData: any) => {
        if (MoleculeData !== null) {
          localStorage.setItem("molecules", JSON.stringify(MoleculeData));
          let referdata: any = localStorage.getItem("molecules");
          let moleculedata: any = JSON.parse(referdata);
          let active_ingredient: any;
          if (Array.isArray(MoleculeData["Active Ingredient"]) === false) {
            active_ingredient = moleculedata["Active Ingredient"].replace(
              /\s/g,
              "%20"
            );
          } else {
            active_ingredient = moleculedata["Active Ingredient"]
              .join("&")
              .replace(/\s/g, "%20");
          }
          let brand_name = moleculedata["Brand Name/Proprietary Name"].replace(
            /\s/g,
            "_"
          ).replaceAll(/%/g, "@");
          let ndaValue = moleculedata["NDA number"];
          let sectionOne = "innovator_details";
          // this.linkURL = `http://${environment.ip}/#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionOne}`;
          this.noData = false;
          // this.ref.detectChanges();
          this.brandNameforPI = brand_name;
          this.ndaforPI = ndaValue;
          this.activeIngredientforPI = active_ingredient;
          let userIp = localStorage.getItem("ipaddress");
          this.homeservice
            .getFirstSection(ndaValue, brand_name, userIp)
            .subscribe((InnovatorDetails: any) => {
              this.Molecule = true;
              this.colorcode =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"][
                "colorindicator"
                ];

              // console.log("1", this.colorcode);
              this.DragData =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              console.log("2", this.DragData);
              this.tempData =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              // console.log("3", this.tempData);
              this.refEditData =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              // console.log("4", this.refEditData);
            });
        } else {
          this.noData = true;
          this.Molecule = false;
          this.DragData = {};
          this.tempData = {};
          this.refEditData = {};
        }
      });
    }
    this.showUploadButton = true;
  }

}
